<template>
  <div id="auditData" class="public-content clearfix">
    <!-- 公共form表单样式 -->
    <div class="form-item-public flex_box">
      <div class='auditData_title'>
        审计数据
      </div>
      <el-form label-width="90px" inline label-position="left" style="text-align: right;" >
        <el-form-item>
          <el-button size="small" class="general_all_btn" @click="isShowSetting = true">审计设置</el-button>
          <!-- <el-button size="small" class="general_all_btn" @click="batchGeneral">批量生成</el-button> -->
          <el-button size="small" class="download_all_btn" @click="batchDownload">批量下载</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 公共table 样式 -->
    <div class="table-item-public">
      <publicTable :table="tableData"  @onHandleoperate="handleOperation">
        <template slot-scope="props" slot="operation">
          <span v-if="props.scope.row.status!=2">
            <span class="item_btn download_btn" @click="itemDownload(props.scope.row)" :class="{'not_allowed':!props.scope.row.status}">下载</span>
            <span v-if="props.scope.row.status === 1" class="item_btn reset_btn" @click="itemGeneral(props.scope.row)">重置</span>
            <span v-else-if="props.scope.row.status === 0" class="item_btn general_btn" @click="itemGeneral(props.scope.row)">生成</span>
          </span>
          <span v-else>
            <span class="not_allowed">生成中</span>
          </span>
				</template>
      </publicTable>
    </div>

    <!-- 审计设置 -->
    <el-dialog
        title="审计设置"
        :visible.sync="isShowSetting"
        append-to-body
        :show-close="false"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        class="default-dialog audit-setting-dialog"
        width="30%"
        center
        @closed="settingForm = $options.data().settingForm"
        @open="getSettingData"
    >
      <el-form ref="form" :model="settingForm" label-position="right" label-width="100px">
        <el-form-item label="财报：">
          <el-radio-group v-model="settingForm.dateType">
            <el-radio :label="0">按季导出</el-radio>
            <el-radio :label="1">按月导出</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-radio-group v-model="settingForm.ruleType">
            <el-radio :label="0">公式法</el-radio>
            <el-radio :label="1">分配法</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="科目余额表：">
          <el-radio-group v-model="settingForm.levelType">
            <el-radio :label="item.value" v-for="item in levelTypeList" :key="item.value">{{item.label}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox-group v-model="settingForm.checkList">
            <el-checkbox label="数量"></el-checkbox>
            <el-checkbox label="辅助核算"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
         <accBtn text="取 消" type="2" @click="isShowSetting = false"/>
         <accBtn text="确 定" @click="settingConfirm"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import publicTable from '@/components/publicTable'
import { findPeriodInfoList, genExcels, auditSave, getSettingByCid, auditDownExcels } from "@/api"

export default {
  components: {
    publicTable
  },
  data() {
    return {
      tableData:{  // 表格数据
        border: true,				// 是否带有纵向边框
				stripe: true,				// 是否带有斑马纹
				loading: false,				// 是否显示加载动画
				hasSelect: true,			// 是否显示多选
				hasOperation: false,		// 是否有操作功能
				hasContextmenu: false,		// 是否有右键功能
				hasShowSummary: false,		// 是否显示合计行
				hasShowPagination: false,	// 是否显示分页
        config: [{
					label: '账套年度',
					value: 'yearNum',
					show: 'normal'
				}, {
					label: '文件生成状态',
					value: 'status',
					show: 'normal',
          formatter:this.statusFormatter
				},{
					label: '生成时间',
					value: 'genDate',
					show: 'normal',
          formatter:this.timeFormatter
				},{
					label: '文件大小',
					value: 'fileSize',
					show: 'normal',
          formatter:this.fileSizeFormatter
				}, {
					label: '操作人',
					value: 'genUser',
					show: 'normal'
				}, {
					label: '操作',
					value: 'operation',
					show: 'template'
				}],
        data: [],
        operation: {
					label: '操作',
					value: 'operation',
					width: 200,
					data: [
						{label:'下载',value:'download'},
						{label:'重置',value:'reset'},
						{label:'生成',value:'general'},
					]
				},
				center: {
					textAlign: 'center',
					padding: '6px 0'
				},
        toggleRowSelection:this.toggleRowSelection,
        selectable: this.selectable
      },
      selectedData:[],
      isShowSetting:false, // 审计设置弹框
      settingForm:{
        dateType:0, // 0.按季 1.按月
        ruleType: 0, // 0.公式法 1.分配法
        levelType: 1, // 科目余额表
        checkList:["数量",'辅助核算'], // 数量 辅助核算
        id:null
      },
      levelTypeList:[
        {
          label:"一级",
          value:1
        },{
          label:"二级",
          value:2
        },{
          label:"三级",
          value:3
        },{
          label:"四级",
          value:4
        },{
          label:"五级",
          value:5
        },
      ]
    };
  },
  created() {
		this.getAuditData();
  },
  computed: {},
  methods: {
    // 请求表格数据
    getAuditData(){
      this.tableData.loading = true
      findPeriodInfoList().then(res=>{
        const {data} = res;
        console.log(data);
        this.tableData.data = data
			}).catch(err=>{
        console.log(err);
      }).finally(()=>{
        this.tableData.loading = false
      });
    },
    // 文件生成状态码转中文
    statusFormatter({status}){
      switch(status){
				case 0:
					return '未生成';
				case 1:
					return '已生成';
        case 2:
          return '生成中';
				default :
					return '未知';
			}
    },
    // 文件大小拼接单位
    fileSizeFormatter({unit,fileSize}){
      if(unit && fileSize) return `${fileSize}${unit}`
      return ''
    },
    // 时间戳转换
    timeFormatter({genDate}){
      if(!genDate) return ''
      const date = new Date(genDate);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();

      const hour = date.getHours() > 9 ? date.getHours() : '0'+ date.getHours();
      const minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
      const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    // 操作按钮
    handleOperation({methods,row}){
      console.log(methods,row);
    },
    // 批量下载
    batchDownload(){
      if(this.selectedData.length === 0) return this.$message.error('请至少选择一条数据！');
      const yearNums = this.selectedData.map(item => item.yearNum);
      const yearStr = yearNums.join(',');

      auditDownExcels({years:yearStr}).then(res=>{
        const path = `/files/${res.data}`
        const router = this.$router.resolve({
          path
        })

        window.open(this.$rootUrl + router.href, '_blank');
      }).catch(err=>{

      })
    },
    // 单个下载
    itemDownload({filePath,status}){
      if(!status) return
      const path = `/files/${filePath}`
      const router = this.$router.resolve({
				path
			})

			window.open(this.$rootUrl + router.href, '_blank');
    },
    // 单个生成
    itemGeneral({id,status}){
      this.tableData.loading = true
      // status = 2
      genExcels({dataId:id}).then(res=>{
        if(res.data.code === '1'){
          this.$message.success(res.data.msg)
          this.getAuditData()
        }else if(res.data === '生成中请稍候'){
          this.$message.success(res.data)
        }
      }).catch(err=>{
      }).finally(()=>{
        this.tableData.loading = false

      })

    },
    // 选项卡勾选
		toggleRowSelection (val) {
      this.selectedData = val
		},
    // 自定义选择框是否禁用
    selectable({status}){
      return [0,2].indexOf(status)>=0?false:true
    },
    // 审计设置确定
    settingConfirm(){
      const { dateType, levelType, ruleType, checkList,id } = this.settingForm
      const param = {
        dateType,
        levelType,
        ruleType,
        needNum: checkList.includes('数量'),
        needCount:checkList.includes('辅助核算'),
        id: id || undefined
      }
      auditSave(param).then(res=>{
        if(res.data.code === '1'){
          this.$message.success(res.data.msg)
          this.isShowSetting = false
        }
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{
        this.getAuditData()
      })
    },
    // 查询审计设置
    getSettingData(){
      getSettingByCid().then(res=>{
        if(res.status === 200){
          const {dateType,levelType,needCount,needNum,ruleType,id} = res.data
          const checkList = []

          if(needCount) checkList.push('辅助核算')
          if(needNum) checkList.push('数量')

          this.settingForm = {
            dateType: dateType != null ? dateType : 0,
            levelType: levelType != null ? levelType : 1,
            ruleType: ruleType != null ? ruleType : 0,
            checkList,
            id
          }
        }
      }).catch(err=>{
        console.log(err);
      }).finally(()=>{

      })
    }
  }
};
</script>

<style lang="less" scoped>

.flex_box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.auditData_title{
  font-weight: 500;
  font-size: 30px;
  color: #333333;
  letter-spacing: 0;
}

/deep/.form-item-public .el-form-item{
  margin-bottom: 0;
  margin-right: 0;
}

.general_all_btn{
  background-color:#F7F7F7;
  border-color:#F7F7F7;
  color:#666;
}
.download_all_btn{
  background-color:#20BD90;
  border-color:#20BD90;
  color:#fff;
}

.item_btn{
  cursor: pointer;
}

.download_btn{
  margin-right: 20px;
}

.not_allowed{
  color: #eee;
  cursor: not-allowed;
}

.general_btn{
  color:#269D7B;
}

.reset_btn{
  color:#FF6010;
}

.audit-setting-dialog{
  .dialog-footer{
    text-align: center;
  }

  /deep/.el-radio__input.is-checked+.el-radio__label{
    color: #269D7B;
  }

  /deep/ .el-radio__input.is-checked .el-radio__inner{
    background: #269D7B;
    border-color: #269D7B;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/auditData.vue